// Centralized media constants — swap any URL here to change site-wide imagery.
const BASE =
  "https://static.prod-images.emergentagent.com/jobs/7525390b-64b7-47a1-a5d7-7069302e7a15/images";

export const IMG = {
  homeHero: `${BASE}/8d7b117bf9927a6eb09e1ee77a38e9793493053521828c17f5ad2b21a9acbc6a.png`,
  problemOverwhelm: `${BASE}/3fc1dd19cee51b4652266ba13af2c661f193605f2ba1a7781854a8301909c40e.png`,
  howItWorksTeam: `${BASE}/ec3e8a5534973fcfcb05f9263a075df73fbc6be4c4dbe8a6406742afee415181.png`,
  aiStandardsReview: `${BASE}/8d9ec9f339723ff39d741809993c63062f33f8e3095c7c49d0843265bef9fc4f.png`,
  aboutTeam: `${BASE}/a4feccdb03d97f8c6473573a4cd0b834938e025cf396895d5e71b5344c4a059c.png`,

  opMarcus: `${BASE}/17d71ce5ce8f0ecc8d22dd9bc5771dbf3ad260cfa32b188311418c14fa4addd8.png`,
  opJordan: `${BASE}/91eef507669e1d7419f0f38850c3f0a52dca7b55b68eab063da2e31b9ab7d886.png`,
  opChris: `${BASE}/ddec9940698908b3ed6ca87aec061d52f1e35d141b8fe5ecfc037b813f60d638.png`,

  solRealEstate: `${BASE}/a9e12b0aed76fa437b3221ed58782985c71431a1d38acb85d845e601d6802feb.png`,
  solHealthcare: `${BASE}/11928cd3ab20f60ed3d6bdf27649e66373c5fa404406a9c15af0d767e7367a54.png`,
  solLegal: `${BASE}/fcabc10ba4dfbd90e411aa4ca4e37a41ae21964c4309c063684d970badfcd0d6.png`,
  solAutomotive: `${BASE}/e4a787173b636e0908349d7bcf1a43656c7ea0b44b2ad5b01785891b648f8629.png`,
  solHomeServices: `${BASE}/953d5a4cd9a7c09ac52c06ee6d1a4d11f8c7474284658a8ee517257cd1225a08.png`,

  clientAlex: `${BASE}/292fb8e120707f4fb90b7f0fac28f3adaf660e21f65d3657c82822802feeba83.png`,
  clientDarius: `${BASE}/166676b4d3dc2ad44d0e804a38c3b41214be4e9f903b8b834c02752a105759e4.png`,
  clientEthan: `${BASE}/caa3d899deb6b4d17b8bc36ae6f2c9299d458ab4ddb2ad938ff90f12a67f5c98.png`,

  marketingHero: `${BASE}/c3f91158556189cd531f9f243b0419ee77abc06da1ea83509e959c73c8b68009.png`,
  creativeHero: `${BASE}/0b47493d08953ef11cf2e1fb286813b1112256f5a5ced4afb89deafe1591cb9e.png`,
  engineeringHero: `${BASE}/0c4ad4857ca55b6a16de1b1e167c84fc6cdca78f52180d21cac928f8fab56409.png`,
};

// Warm human avatar placeholders for the pre-built platform agents. Swap per brand.
export const AGENT_AVATAR = {
  sales: `${process.env.PUBLIC_URL}/agents/korean-male.jpg`,
  marketer: `${process.env.PUBLIC_URL}/agents/curly-male.jpg`,
  reputation: `${process.env.PUBLIC_URL}/agents/bald-male.jpg`,
  receptionist: `${process.env.PUBLIC_URL}/agents/pakistani-female.jpg`,
  scheduler: `${process.env.PUBLIC_URL}/agents/black-female.jpg`,
  custom1: `${process.env.PUBLIC_URL}/agents/pakistani-male.jpg`,
  custom2: `${process.env.PUBLIC_URL}/agents/curly-male.jpg`,
  custom3: `${process.env.PUBLIC_URL}/agents/korean-male.jpg`,
};

// Placeholder demo video — swap per-agent with the real clip.
export const DEMO_VIDEO = {
  a: "https://videos.pexels.com/video-files/3205618/3205618-hd_1920_1080_25fps.mp4",
  b: "https://videos.pexels.com/video-files/5717426/5717426-hd_1920_1080_25fps.mp4",
  c: "https://videos.pexels.com/video-files/3254066/3254066-hd_1920_1080_25fps.mp4",
  d: "https://videos.pexels.com/video-files/6774633/6774633-hd_1920_1080_30fps.mp4",
};

// Vetted warm, human, documentary stock video (Pexels) — single swappable src per hero.
export const VIDEO = {
  home: `${process.env.PUBLIC_URL}/videos/home.mp4`,
  marketing: "https://videos.pexels.com/video-files/3205618/3205618-hd_1920_1080_25fps.mp4",
  creative: `${process.env.PUBLIC_URL}/videos/creative.mp4`,
  unfair: `${process.env.PUBLIC_URL}/videos/unfair.mp4`,
  standards: `${process.env.PUBLIC_URL}/videos/standards.mp4`,
  closing: `${process.env.PUBLIC_URL}/videos/closing.mp4`,
  engineering: `${process.env.PUBLIC_URL}/videos/problem.mp4`,
  workflow: `${process.env.PUBLIC_URL}/videos/workflow.mp4`,
  competitors: `${process.env.PUBLIC_URL}/videos/competitors.mp4`,
  growth: `${process.env.PUBLIC_URL}/videos/growth.mp4`,
  product: `${process.env.PUBLIC_URL}/videos/product.mp4`,
  pricing: `${process.env.PUBLIC_URL}/videos/pricing.mp4`,
  careers: `${process.env.PUBLIC_URL}/videos/careers.mp4`,
  labs: `${process.env.PUBLIC_URL}/videos/labs.mp4`,
  brands: `${process.env.PUBLIC_URL}/videos/brands.mp4`,
};

// Poster stills captured directly from the matching background videos so the
// static fallback shows the same frame as the video.
export const POSTER = {
  home: `${process.env.PUBLIC_URL}/videos/home.jpg`,
  engineering: `${process.env.PUBLIC_URL}/videos/problem.jpg`,
  unfair: `${process.env.PUBLIC_URL}/videos/unfair.jpg`,
  standards: `${process.env.PUBLIC_URL}/videos/standards.jpg`,
  closing: `${process.env.PUBLIC_URL}/videos/closing.jpg`,
  workflow: `${process.env.PUBLIC_URL}/videos/workflow.jpg`,
  competitors: `${process.env.PUBLIC_URL}/videos/competitors.jpg`,
  growth: `${process.env.PUBLIC_URL}/videos/growth.jpg`,
  creative: `${process.env.PUBLIC_URL}/videos/creative.jpg`,
  product: `${process.env.PUBLIC_URL}/videos/product.jpg`,
  pricing: `${process.env.PUBLIC_URL}/videos/pricing.jpg`,
  careers: `${process.env.PUBLIC_URL}/videos/careers.jpg`,
  labs: `${process.env.PUBLIC_URL}/videos/labs.jpg`,
  brands: `${process.env.PUBLIC_URL}/videos/brands.jpg`,
};
